import { call, fork, put, takeEvery } from 'redux-saga/effects';

import actionTypes from '@atom/actions/actionTypes';
import * as userActions from '@atom/actions/userActions';
import { Snackbar } from '@atom/mui';
import accountUtilities from '@atom/utilities/accountUtilities';
import api from '@atom/utilities/api';
import { REGISTRATION_ENDPOINT } from '@atom/utilities/endpoints';

export function* registerUser(action) {
  try {
    yield call(api.post, REGISTRATION_ENDPOINT, action.data);
    const { email, password } = action.data;

    const result = yield call(
      accountUtilities.individualAccountLogin,
      email,
      password,
    );

    yield put(
      userActions.requestUserAuthTokenExchange({
        accessToken: result.accessToken,
      }),
    );
  } catch (error) {
    Snackbar.error({
      message: 'This email account already exists.',
    });

    yield fork(
      accountUtilities.apiErrorHandler,
      error,
      userActions.userRegisterFailure,
    );
  }
}

/* WATCHERS */
export function* requestUserRegistration() {
  yield takeEvery(actionTypes.REQUEST_USER_REGISTER, registerUser);
}

export default [requestUserRegistration];
